import { Controller } from '@hotwired/stimulus';

/**
 * 画像アップロード制御
 */
export default class extends Controller<HTMLElement> {
  static override targets = ['input', 'preview'];
  static override values = { initialSrc: String };

  declare readonly inputTarget: HTMLInputElement;
  declare readonly previewTarget: HTMLImageElement;
  declare readonly hasInitialSrcValue: boolean;
  declare readonly initialSrcValue: string;

  private objectUrl: string | undefined;

  override connect(): void {
    // 既存画像があれば初期表示、なければ非表示
    if (this.hasInitialSrcValue && this.initialSrcValue) {
      this.previewTarget.src = this.initialSrcValue;
      this.showPreview();
    } else {
      this.hiddenPreview();
    }
  }

  override disconnect(): void {
    this.revokeUrl();
  }

  /**
   * ファイル選択ダイアログを開く
   */
  openFileDialog(): void {
    this.inputTarget?.click();
  }

  /**
   * ファイル選択時の処理（正確にはファイル選択ダイアログを開いた後の処理）
   */
  onFileChange(): void {
    const file = this.inputTarget?.files?.[0];

    // ファイルが選択されていない場合は何もしない
    if (!file) {
      return;
    }

    this.revokeUrl();
    const url = URL.createObjectURL(file);
    this.objectUrl = url;
    this.previewTarget.src = url;
    this.showPreview();
  }

  /**
   * プレビューを非表示
   */
  private hiddenPreview(): void {
    this.previewTarget.classList.add('hidden');
  }

  /**
   * プレビューを表示
   */
  private showPreview(): void {
    this.previewTarget.classList.remove('hidden');
  }

  /**
   * プレビューのURLを破棄
   */
  private revokeUrl(): void {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
      this.objectUrl = undefined;
    }
  }
}
